import { useEffect } from 'react';
import Banner from '../../components/common/Banner';
import SiteLayout from '../../components/common/SiteLayout';
import usePageMeta from '../../components/common/usePageMeta';

const GHL_URL = 'https://api.leadconnectorhq.com/widget';
const FORM_EMBED_SRC = 'https://link.msgsndr.com/js/form_embed.js';
const SCROLL_HANDLER_SRC = 'https://s3.us-east-1.amazonaws.com/revolt-tv.embed/js/form-scroll-handler.js';

const loadScriptOnce = (src) => {
    if (document.querySelector(`script[src="${src}"]`)) return;
    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    document.body.appendChild(script);
};

function Embed({ page }) {
    if (page.form) {
        return (
            <iframe
                src={`${GHL_URL}/form/${page.form}`}
                style={{ width: '100%', height: '100%', border: 'none', borderRadius: '3px' }}
                id={`inline-${page.form}`}
                data-layout="{'id':'INLINE'}"
                data-trigger-type="alwaysShow"
                data-trigger-value=""
                data-activation-type="alwaysActivated"
                data-activation-value=""
                data-deactivation-type="neverDeactivate"
                data-deactivation-value=""
                data-form-name="Form 0"
                data-height="725"
                data-layout-iframe-id={`inline-${page.form}`}
                data-form-id={page.form}
                title="Form 0"
                allow="payment *"
            />
        );
    }

    return (
        <iframe
            src={`${GHL_URL}/survey/${page.survey}`}
            style={{ border: 'none', width: '100%' }}
            scrolling="no"
            id={page.survey}
            title="survey"
            allow="payment *"
        />
    );
}

export default function FormPage({ page }) {
    const [before, highlight, after] = page.title.split(/\[(.+)\]/);
    const green = page.banner ? 'text-[#00E387]' : 'text-[#22c55e]';
    const title = <>{before}<span className={green}>{highlight}</span>{after}</>;

    usePageMeta(page, { formOg: true });

    useEffect(() => {
        loadScriptOnce(FORM_EMBED_SRC);
        if (page.scrollHandler) loadScriptOnce(SCROLL_HANDLER_SRC);
        if (page.pixelEvent) window.fbq?.('track', ...page.pixelEvent);
    }, [page]);

    return (
        <SiteLayout headerVariant={page.header} overlayHeader={page.banner} mainClassName={page.banner ? '' : 'bg-white'}>
            {page.banner && (
                <Banner>
                    <h1 className="font-['Mango_Grotesque'] text-[90px] font-extrabold uppercase leading-[0.8] min-[861px]:text-[110px] min-[1141px]:text-[170px]">
                        {title}
                    </h1>
                    {page.intro && (
                        <div className="leading-[1.4]">
                            {page.intro.map((line) => (
                                <p
                                    key={line.text}
                                    className={line.green ? 'text-[24px] text-[#00e387]' : 'mb-[1.6875rem] text-[26px] font-bold'}
                                >
                                    {line.text}
                                </p>
                            ))}
                        </div>
                    )}
                </Banner>
            )}

            <div className={`px-[15px] pb-8 md:pb-16 ${page.banner ? '' : 'pt-8 text-[#121212] md:pt-6'}`}>
                {!page.banner && (
                    <h1 className="mb-8 text-center font-['Mango_Grotesque'] text-[48px] font-bold uppercase leading-[0.85] md:mb-6 md:text-[64px] min-[1025px]:leading-[1.125]">
                        {title}
                    </h1>
                )}

                <div
                    className={`mx-auto w-full rounded-[20px] border border-[#DDE2E5] px-[30px] pb-[30px] pt-[60px] max-[640px]:border-x-0 max-[640px]:px-0 max-[640px]:pt-[30px] ${page.card === 'wide' ? 'max-w-[860px]' : 'max-w-[816px]'} ${page.card === 'dark' ? 'bg-[#070038]' : 'bg-white'}`}
                >
                    <Embed page={page} />
                </div>
            </div>
        </SiteLayout>
    );
}
